// src/hooks/programs/useForceDeleteAllPrograms.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllPrograms } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useForceDeleteAllPrograms = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllProgramsMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: forceDeleteAllPrograms,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["programs"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete programs");
        },
    });

    return {
        forceDeleteAllProgramsMutate,
        isPending: isPending || isLoading,
    };
};

export default useForceDeleteAllPrograms;
